document.addEventListener('DOMContentLoaded',function(){

  var path = window.location.pathname.replace(/\/$/, '').toLowerCase();

  var isAboutUs =
    path === '/pages/about-us-coy-eyewear' ||
    path === '/it/pages/about-us-coy-eyewear' ||
    path === '/fr/pages/about-us-coy-eyewear';

  var isProductPage    = /^\/(?:it|fr)?\/?products\//.test(path);
  var isCollectionPage = /^\/(?:it|fr)?\/?collections(\/|$)/.test(path);

  if (isAboutUs || isProductPage || isCollectionPage) {
    document.body.classList.add('coy-no-ap-behaviour');
    return;
  }

  /* Reveal unification: the image and video load wiring lives in assets/coy-reveal.js —
     one producer for all media reveal state (`is-loaded` / `coy-video-ready`). What stays
     here is this file's NON-reveal work: the page-type exclusion gate above, and the
     LCP/decoding hints below. */

  /* IMAGE HINTS (kept): decoding + LCP boost for the first images — skip product-card images
     with a hover swap (forcing them eager pins them at opacity:1 !important, which breaks the
     theme's hover fade between first and second image). */
  document.querySelectorAll('.shopify-section img').forEach(function(img, i){
    if(!img.decoding) img.decoding = 'async';
    if(i < 4 && !img.closest('.media--hover-effect')){
      img.loading = 'eager';
      img.fetchPriority = 'high';
    }
  });

  /* TEXT REVEAL — choreography kept verbatim (same selectors, exclusions, and stagger); the
     observer machinery is the shared contract (coy-reveal.js). data-reveal-margin preserves
     this system's original trigger geometry (rootMargin 120px below the viewport). Stage 5:
     the coy-in alias is retired — `animated` is the one state class. */
  var textEls = document.querySelectorAll(`
    .shopify-section .rte p,
    .shopify-section .product__description p,
    .shopify-section .collection-hero__description p,
    .shopify-section .image-with-text__content p,
    .shopify-section .rich-text__text p,
    .shopify-section .media-banner__description p,
    .shopify-section .content-card .description p,
    .shopify-section .text-block p,
    .shopify-section .content-block p,
    .shopify-section .banner__text p
  `);

  textEls.forEach(function(el,index){
    if(
      el.closest('header') ||
      el.closest('.header') ||
      el.closest('nav') ||
      el.closest('.menu') ||
      el.closest('.products-tabs__title') ||
      el.closest('.testimonials-slider-slide__text')
    ){
      return;
    }

    el.classList.add('coy-reveal-text');
    el.style.transitionDelay = Math.min(index % 4, 3) * 0.05 + 's';

    if (window.CoyReveal) {
      el.setAttribute('data-reveal-margin', '0px 0px 120px 0px');
      window.CoyReveal.observe(el);
    } else {
      /* Utility missing: never leave content hidden — settle immediately. */
      el.classList.add('animated');
    }
  });

});